/*
* PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
* Copyright (c) 2017 Pearson Education, Inc.
* All Rights Reserved.
*
* NOTICE: All information contained herein is, and remains the property of
* Pearson Education, Inc. The intellectual and technical concepts contained
* herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
* and Foreign Patents, patent applications, and are protected by trade secret
* or copyright law. Dissemination of this information, reproduction of this
* material, and copying or distribution of this software is strictly forbidden
* unless prior written permission is obtained from Pearson Education, Inc.
*/

import React from 'react'
import PropTypes from 'prop-types'
import { IntlProvider, FormattedMessage, FormattedDate } from 'react-intl'

class Footer extends React.Component {
  static propTypes = {
    copyrightText: PropTypes.string,
    links: PropTypes.array.isRequired,
    light: PropTypes.bool,
    singlePageStick: PropTypes.bool,
    anchorTarget: PropTypes.oneOf(['_blank', '_self', '_parent', '_top'])
  }

  static defaultProps = {
    light: false,
    singlePageStick: false,
    anchorTarget: '_self'
  }

  renderCopy () {
    return (<p className='pe-label'>
      <FormattedMessage id='common.copyright' defaultMessage='Copyright' description='A label for the word Copyright' />&copy;
      <FormattedDate value={new Date()} year='numeric' /> {this.props.copyrightText}
    </p>)
  }

  renderLinks () {
    let items = []
    const { links, anchorTarget } = this.props

    for (let i = 0; i < links.length; i++) {
      let item = links[i]
      items.push(<li key={i}>
        <a href={item.href} target={anchorTarget}>{item.text}</a>
        <span aria-hidden>|</span>
      </li>)
    }
    return items
  }

  render () {
    const { light, singlePageStick } = this.props
    const lightCheck = light ? 'pe-footer--light' : ''
    const stickCheck = singlePageStick ? '--stick' : ''

    return (
      <IntlProvider locale='en' messages={[{ 'common.copyright': 'Copyright' }]}>
        <footer className={`pe-footer${stickCheck} pe-label ${lightCheck}`}>
          <ul>
            {this.renderLinks()}
          </ul>
          {this.renderCopy()}
        </footer>
      </IntlProvider>

    )
  }
}
export default Footer
